import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-PrivateMarketplaceShape",
  "use": "svg-icon-PrivateMarketplaceShape-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-PrivateMarketplaceShape\"><g fill-rule=\"evenodd\"><path d=\"M0 15h7v-3H0zM6 0L0 6l3 3.056L8.964 3z\" /><path d=\"M4 5l9 9 1-1-9-9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol